import React from 'react';
import PropTypes from 'prop-types';

export default function ServiceTitlePres({ title }) {
  return (
    <div className="ssi-title">
      <h2>{title}</h2>
      <div className="ssi-divider" />
    </div>
  );
}

ServiceTitlePres.propTypes = {
  title: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/features/ServiceInit/presentational/ServiceTitlePres.js